// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.shipping-type[data-v-e6c26566] {\n  max-width: 50%;\n  height: 95px;\n  overflow-y: auto;\n}\n", ""]);
// Exports
module.exports = exports;
